import {getTestProps} from '@benchling/js-test-utils';
import moment from 'moment';
import React from 'react';
import _ from 'underscore';

export default function CalendarWeekHeader(): JSX.Element {
  return (
    <table className="calendarTable" {...getTestProps({component: 'CalendarWeekHeader', element: 'root'})}>
      <thead>
        <tr>
          {_.range(7).map((dayNum) => (
            <th key={dayNum} className="calendarTable-day">
              {moment().day(dayNum).format('ddd')}
            </th>
          ))}
        </tr>
      </thead>
    </table>
  );
}
